const styles = (theme) => ({
  allRecommendationContainer: {
    position: "absolute",
    pointerEvents: "auto",
    right: 5,
    top: 5,
    maxWidth: "90%",
    display: "flex",
    flexDirection: "column",
    padding: 16,
    backgroundColor: theme.ComponentHeader,
    borderRadius: 4,
    width: 431,
    maxHeight: "70%",
    boxShadow:"1px 1px 4px",
    zIndex: 100
  },
  innerAllRecommendationContainer: {
    overflow: "auto",
  },
  recommendationContainer: {
    backgroundColor: theme.ModalBGColor,
  },
  recommendedDrivers: {
    height: "101px",
    margin: 1,
    marginBottom: "5px",
  },
  upperDetails: {
    borderBottom: "1px solid #D8D8D8",
    height: "50%",
    position: "relative",
  },
  routeIcon: {
    width: "15px",
    height: "50%",
    position: "absolute",
    top: "27%",
    left: "4%",
  },
  detailsContainer: {
    position: "absolute",
    top: "10%",
    left: "10%",
    display: "flex",
    width: "58%",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  bestChoice: {
    width: 78,
    color: "#E5A70D",
    fontWeight: 700,
    display: "block",
  },
  driverName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  upperEnrouteToTitle: {
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 600,
    color: theme.recommendationCardStatusTextColor,
  },
  upperEnrouteToValue: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    color: theme.gridTextColor,
  },

  assignBtn: {
    position: "absolute",
    top: "24%",
    right: "2%",
    width: "25%",
    height: "56%",
  },
  lowerDetails: { height: "50%", position: "relative" },
  tableHeaderCell: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.recommendationCardStatusTextColor,
    fontWeight: 400,
    padding: 0,
    paddingLeft: "14px",
    paddingTop: "8px",
    border: "none",
  },
  tableDataCell: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    padding: 0,
    paddingLeft: "14px",
    border: "none",
    color: theme.gridTextColor,
  },
  tableRow: {
    height: "18px",
  },

  enrouteTo: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    padding: 0,
    paddingLeft: "14px",
    border: "none",
    color: theme.gridTextColor,
    width: "100px",
  },
  missedStops: {
    color: theme.violationsTextColor,
  },
  loader: {
    alignSelf: "center",
  },
  error: {
    color: theme.ErrorMessageColor,
  },
  noRecommendations: { textAlign: "center" },
  driverNameContainer: {
    width: 192,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  driverNameContainerWithBestChoice: {
    width: 158,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
});

export default styles;